// @flow
import config from 'Config';
import { createStore, applyMiddleware, compose } from 'redux';
import optimistPromise from 'redux-optimist-promise';
import thunk from 'redux-thunk';
import { isStrictlyDevelopmentEnv } from 'Utils/context/contextUtils';

import { createAuthenticationMiddleware } from './middlewares/authenticationMiddleware';
import { rootReducer } from './rootReducer';

function getReduxMiddlewares() {
  return [thunk, optimistPromise(), createAuthenticationMiddleware()];
}

export function init(initialState?: $Shape<ReduxState>): ReduxState {
  const enhancer = isStrictlyDevelopmentEnv(config)
    ? (global.window && global.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose
    : compose;

  return createStore(
    rootReducer,
    initialState,
    enhancer(applyMiddleware(...getReduxMiddlewares())),
  );
}
